import { SaveData } from "./SaveData";

export default abstract class PlayerData {
	public static Instance: PlayerData;
	protected _isLoaded: boolean;
	public abstract get saveData(): SaveData;
	public abstract get onLoaded(): () => void;
	public abstract set onLoaded(f: () => void);
	abstract load(): void;
	abstract save(): void;
	abstract reset(): void;
	public isLoaded(): boolean {
		return this._isLoaded;
	}
}
